// === Geometry ===
// === Classes ===
export var ClassType;
(function (ClassType) {
    ClassType["Warrior"] = "warrior";
    ClassType["Mage"] = "mage";
    ClassType["Priest"] = "priest";
    ClassType["Paladin"] = "paladin";
})(ClassType || (ClassType = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["Rage"] = "rage";
    ResourceType["Mana"] = "mana";
})(ResourceType || (ResourceType = {}));
// === Abilities ===
export var AbilityId;
(function (AbilityId) {
    // Warrior
    AbilityId["Charge"] = "charge";
    AbilityId["MortalStrike"] = "mortal_strike";
    AbilityId["ShieldBlock"] = "shield_block";
    AbilityId["Execute"] = "execute";
    AbilityId["Hamstring"] = "hamstring";
    // Mage
    AbilityId["Fireball"] = "fireball";
    AbilityId["FrostNova"] = "frost_nova";
    AbilityId["Blink"] = "blink";
    AbilityId["Polymorph"] = "polymorph";
    AbilityId["IceBarrier"] = "ice_barrier";
    AbilityId["Counterspell"] = "counterspell";
    // Paladin
    AbilityId["CrusaderStrike"] = "crusader_strike";
    AbilityId["HammerOfJustice"] = "hammer_of_justice";
    AbilityId["FlashOfLight"] = "flash_of_light";
    AbilityId["DivineShield"] = "divine_shield";
    AbilityId["Consecration"] = "consecration";
    // Priest
    AbilityId["Heal"] = "heal";
    AbilityId["ShadowWordPain"] = "shadow_word_pain";
    AbilityId["PowerWordShield"] = "power_word_shield";
    AbilityId["Smite"] = "smite";
    AbilityId["PsychicScream"] = "psychic_scream";
})(AbilityId || (AbilityId = {}));
export var TargetType;
(function (TargetType) {
    TargetType["Enemy"] = "enemy";
    TargetType["Self"] = "self";
    TargetType["Friendly"] = "friendly";
})(TargetType || (TargetType = {}));
// === Buffs / Debuffs ===
export var BuffType;
(function (BuffType) {
    // Debuffs
    BuffType["Root"] = "root";
    BuffType["Slow"] = "slow";
    BuffType["MortalWound"] = "mortal_wound";
    BuffType["Polymorph"] = "polymorph";
    BuffType["Fear"] = "fear";
    BuffType["ShadowWordPain"] = "shadow_word_pain";
    // Buffs
    BuffType["ShieldBlock"] = "shield_block";
    BuffType["IceBarrier"] = "ice_barrier";
    BuffType["PowerWordShield"] = "power_word_shield";
    BuffType["Silence"] = "silence";
    BuffType["Stun"] = "stun";
    BuffType["DivineShield"] = "divine_shield";
})(BuffType || (BuffType = {}));
// === CC Diminishing Returns ===
export var DRCategory;
(function (DRCategory) {
    DRCategory["Root"] = "root";
    DRCategory["Stun"] = "stun";
    DRCategory["Incapacitate"] = "incapacitate";
    DRCategory["Fear"] = "fear";
})(DRCategory || (DRCategory = {}));
// === Arena / Match ===
export var MatchPhase;
(function (MatchPhase) {
    MatchPhase["Waiting"] = "waiting";
    MatchPhase["Countdown"] = "countdown";
    MatchPhase["Active"] = "active";
    MatchPhase["Finished"] = "finished";
})(MatchPhase || (MatchPhase = {}));
export var GameMode;
(function (GameMode) {
    GameMode["Arena1v1"] = "1v1";
    GameMode["Arena2v2"] = "2v2";
})(GameMode || (GameMode = {}));
// === Messages ===
export var ClientMessageType;
(function (ClientMessageType) {
    ClientMessageType["Login"] = "login";
    ClientMessageType["Logout"] = "logout";
    ClientMessageType["Move"] = "move";
    ClientMessageType["StopMove"] = "stop_move";
    ClientMessageType["Rotate"] = "rotate";
    ClientMessageType["UseAbility"] = "use_ability";
    ClientMessageType["SetTarget"] = "set_target";
    ClientMessageType["QueueJoin"] = "queue_join";
    ClientMessageType["QueueLeave"] = "queue_leave";
    ClientMessageType["CancelCast"] = "cancel_cast";
})(ClientMessageType || (ClientMessageType = {}));
export var ServerMessageType;
(function (ServerMessageType) {
    ServerMessageType["LoginOk"] = "login_ok";
    ServerMessageType["StateUpdate"] = "state_update";
    ServerMessageType["QueueUpdate"] = "queue_update";
    ServerMessageType["LobbyStatus"] = "lobby_status";
    ServerMessageType["MatchStart"] = "match_start";
    ServerMessageType["MatchEnd"] = "match_end";
    ServerMessageType["CombatEvent"] = "combat_event";
    ServerMessageType["Error"] = "error";
})(ServerMessageType || (ServerMessageType = {}));
export var CombatEventType;
(function (CombatEventType) {
    CombatEventType["Damage"] = "damage";
    CombatEventType["Heal"] = "heal";
    CombatEventType["BuffApplied"] = "buff_applied";
    CombatEventType["BuffRemoved"] = "buff_removed";
    CombatEventType["AbilityUsed"] = "ability_used";
    CombatEventType["Death"] = "death";
    CombatEventType["Interrupt"] = "interrupt";
    CombatEventType["Miss"] = "miss";
    CombatEventType["Immune"] = "immune";
    CombatEventType["Absorb"] = "absorb";
})(CombatEventType || (CombatEventType = {}));
//# sourceMappingURL=index.js.map